// API (later these constants to be read from appConfig)
export const APP_CONFIG = window.tcom.researchInsights.appConfig || {};
export const API_BASE_PATH = APP_CONFIG.useAlternateApi ? APP_CONFIG.alternateApiBasePath : APP_CONFIG.apiBasePath;
export const API_ENDPOINTS = APP_CONFIG.apiEndPoints || {};
// export const API_BASE_PATH = 'https://svc-b2b-research-insight.apps.np.sdppcf.com/v1/b2b';

export const AEM_API_BASE_PATH = APP_CONFIG.aemArticleBasePath;
export const AEM_AUTHOR_ENDPOINT = APP_CONFIG.authorBasePath;
export const AEM_AUTHOR_ENDPOINT_SSM = APP_CONFIG.authorBasePathSSM;
export const AEM_AUTHOR_ENDPOINT_FFWD = APP_CONFIG.authorBasePathFFWD;
export const AEM_AUTHOR_ENDPOINT_NGM = APP_CONFIG.authorBasePathNGM;
export const AEM_AUTHOR_ENDPOINT_AMS = APP_CONFIG.authorBasePathAMS;
export const AEM_AUTHOR_ENDPOINT_AMC = APP_CONFIG.authorBasePathAMC;
export const AEM_AUTHOR_ENDPOINT_AMP = APP_CONFIG.authorBasePathAMP;
export const AEM_AUTHOR_ENDPOINT_SCT = APP_CONFIG.authorBasePathSCT;
export const AEM_VANTAGE_AUTHOR_ENDPOINT = APP_CONFIG.vantageAuthorBasePath;
export const AEM_HOSTED_MIGRATION_AUTHOR_ENDPOINT = APP_CONFIG.hostedMigrationAuthorBasePath;
export const AEM_BUSINESS_POP_MAIL_AUTHOR_ENDPOINT = APP_CONFIG.businessPopMailAuthorBasePath;
export const AEM_ADAPTIVE_MOBILITY_EXTERNAL_AUTHOR_ENDPOINT = APP_CONFIG.adaptiveMobilityExternalAuthorBasePath;


// ACTIONS
export const READ_MORE_SETTING = {
  linkText: 'Read more',
  heroLineLimit: 7,
  subHeroLineLimit: 2,
  minHeroLineLimit: 1,
  normalLineLimit: 3,
};
export const API_ERROR = 'API_ERROR';

export const API_ARTICLES_ENDPOINT = API_ENDPOINTS.articles;
export const API_INITIATE_ARTICLES = 'API_INITIATE_ARTICLES';
export const API_COMPLETE_ARTICLES = 'API_COMPLETE_ARTICLES';
export const API_ERROR_ARTICLES = 'API_ERROR_ARTICLES';

export const API_INITIATE_ARTICLE_DETAIL = 'API_INITIATE_ARTICLE_DETAIL';
export const API_COMPLETE_ARTICLE_DETAIL = 'API_COMPLETE_ARTICLE_DETAIL';

export const AEM_API_ARTICLE_CONTENT_ENDPOINT = API_ENDPOINTS.articleContent;
export const AEM_API_INITIATE_ARTICLE_CONTENT = 'AEM_API_INITIATE_ARTICLE_CONTENT';
export const AEM_API_COMPLETE_ARTICLE_CONTENT = 'AEM_API_COMPLETE_ARTICLE_CONTENT';
export const AEM_API_ERROR_ARTICLE_CONTENT = 'AEM_API_ERROR_ARTICLE_CONTENT';
export const ARTICLE_READING_TIME_TEXT = 'minute read';
export const CLEAR_ARTICLE_CONTENT = 'CLEAR_ARTICLE_CONTENT';

export const API_MARKET_COMPARISON_ENDPOINT = API_ENDPOINTS.marketComparison;
export const API_INITIATE_MARKET_COMPARISON = 'API_INITIATE_MARKET_COMPARISON';
export const API_COMPLETE_MARKET_COMPARISON = 'API_COMPLETE_MARKET_COMPARISON';

export const API_PRODUCT_RECOMMENDATION_ENDPOINT = API_ENDPOINTS.productRecommendation;
export const API_INITIATE_PRODUCT_RECOMMENDATION = 'API_INITIATE_PRODUCT_RECOMMENDATION';
export const API_COMPLETE_PRODUCT_RECOMMENDATION = 'API_COMPLETE_PRODUCT_RECOMMENDATION';
export const UPDATE_PRODUCT_RECOMMENDATION = 'UPDATE_PRODUCT_RECOMMENDATION';
export const UPDATE_ALL_PRODUCT_RECOMMENDATION = 'UPDATE_ALL_PRODUCT_RECOMMENDATION';
export const BUSINESS_CASE_BUILDER_SELECT_ALL = 'BUSINESS_CASE_BUILDER_SELECT_ALL';
export const API_UPDATE_PRODUCT_RECOMMENDATION = 'API_UPDATE_PRODUCT_RECOMMENDATION';
export const RESET_PRODUCT_RECOMMENDATIONS = 'RESET_PRODUCT_RECOMMENDATIONS';

export const API_VANTAGE_ENDPOINT = API_ENDPOINTS.vantageContent;
export const API_INITIATE_VANTAGE_ENDPOINT = 'API_INITIATE_VANTAGE_ENDPOINT';
export const API_COMPLETE_VANTAGE_ENDPOINT = 'API_COMPLETE_VANTAGE_ENDPOINT';

export const CALLBACK_REQUEST_ENDPOINT = API_ENDPOINTS.requestCallback;
export const OPEN_CALLBACK_REQUEST_MODAL = 'OPEN_CALLBACK_REQUEST_MODAL';
export const CLOSE_CALLBACK_REQUEST_MODAL = 'CLOSE_CALLBACK_REQUEST_MODAL';
export const INITIATE_CALLBACK_REQUEST = 'INITIATE_CALLBACK_REQUEST';
export const COMPLETE_CALLBACK_REQUEST = 'COMPLETE_CALLBACK_REQUEST';

export const INITIATE_AUTHOR_CONTENT = 'INITIATE_AUTHOR_CONTENT';
export const COMPLETE_AUTHOR_CONTENT = 'COMPLETE_AUTHOR_CONTENT';
export const ERROR_AUTHOR_CONTENT = 'ERROR_AUTHOR_CONTENT';
export const API_GENERAL_ERROR = 'API_GENERAL_ERROR';

export const INITIATE_NEW_BUSINESS_CASE = 'INITIATE_NEW_BUSINESS_CASE';
export const INITIATE_EXISTING_BUSINESS_CASE = 'INITIATE_EXISTING_BUSINESS_CASE';
export const REVIEW_BUSINESS_CASE = 'REVIEW_BUSINESS_CASE';
export const SAVE_BUSINESS_CASE = 'SAVE_BUSINESS_CASE';
export const ACTIVATE_SELECTED_BUSINESS_CASE = 'ACTIVATE_SELECTED_BUSINESS_CASE';
export const UPDATE_BUSINESS_CASE_FORM_STATE = 'UPDATE_BUSINESS_CASE_FORM_STATE';
export const API_GET_BUSINESS_CASES_LIST_COMPLETE = 'API_GET_BUSINESS_CASES_LIST_COMPLETE';
export const INITIATE_BUSINESS_CASE_FORM_VALIDATION = 'INITIATE_BUSINESS_CASE_FORM_VALIDATION';
export const COMPLETE_BUSINESS_CASE_FORM_VALIDATION = 'COMPLETE_BUSINESS_CASE_FORM_VALIDATION';
export const API_DELETE_BUSINESS_CASE_COMPLETE = 'API_DELETE_BUSINESS_CASE_COMPLETE';
export const API_SAVE_BUSINESS_CASE_ENDPOINT = API_ENDPOINTS.saveBusinessCase;
export const API_GET_ALL_BUSINESS_CASES_ENDPOINT = API_ENDPOINTS.getAllBusinessCases;
export const API_DELETE_BUSINESS_CASE_ENDPOINT = API_ENDPOINTS.deleteBusinessCase;
export const API_NOTIFY_ENDPOINT = API_ENDPOINTS.notifyEndpoint;
export const INITIATE_ACCOUNT_MANAGER_NOTIFICATION_PROCESS = 'INITIATE_ACCOUNT_MANAGER_NOTIFICATION_PROCESS';
export const COMPLETE_ACCOUNT_MANAGER_NOTIFICATION_PROCESS = 'COMPLETE_ACCOUNT_MANAGER_NOTIFICATION_PROCESS';
export const API_DOWNLOAD_PDF_ENDPOINT = API_ENDPOINTS.downloadPdfEndpoint;
export const INITIATE_DOWNLOAD_PDF_PROCESS = 'INITIATE_DOWNLOAD_PDF_PROCESS';
export const COMPLETE_DOWNLOAD_PDF_PROCESS = 'COMPLETE_DOWNLOAD_PDF_PROCESS';
export const SAVE_PRODUCTS_TO_BUSINESS_CASE = 'SAVE_PRODUCTS_TO_BUSINESS_CASE';

export const INITIATE_EVENT_DOWNLOAD_PDF_PROCESS = 'INITIATE_EVENT_DOWNLOAD_PDF_PROCESS';
export const COMPLETE_EVENT_DOWNLOAD_PDF_PROCESS = 'COMPLETE_EVENT_DOWNLOAD_PDF_PROCESS';
export const FAILURE_EVENT_DOWNLOAD_PDF_PROCESS = 'FAILURE_EVENT_DOWNLOAD_PDF_PROCESS';
export const API_DOWNLOAD_EVENT_PDF_ENDPOINT = API_ENDPOINTS.downloadEventPdfEndpoint;

export const INITIATE_EMAIL_EVENT_REPORT = 'INITIATE_EMAIL_EVENT_REPORT';
export const COMPLETE_EMAIL_EVENT_REPORT = 'COMPLETE_EMAIL_EVENT_REPORT';
export const FAILURE_EMAIL_EVENT_REPORT = 'FAILURE_EMAIL_EVENT_REPORT';
export const API_SEND_EMAIL_EVENT_ENDPOINT = API_ENDPOINTS.emailEventReportEndpoint;

export const HIDE_GENERIC_ERROR_MODAL = 'HIDE_GENERIC_ERROR_MODAL';

export const START_EVENT_RESOURCE_TRACK = 'START_EVENT_RESOURCE_TRACK';
export const COMPLETE_EVENT_RESOURCE_TRACK = 'COMPLETE_EVENT_RESOURCE_TRACK';
export const API_EVENT_TRACK_RESOURCE_ENDPOINT = API_ENDPOINTS.eventsTrackResourceViews;

export const UPDATE_SELECTED_SLIDES = 'UPDATE_SELECTED_SLIDES';

// path for IE testing in virtual box
// export const API_BASE_PATH = 'http://10.0.2.2:8080/v1/b2b';
// css constants
/* Three layouts used - look for references in code
  HERO:
    large image on the left with heading and text on the right
    <col-sm-7> <col-sm-5>
  SUB_HERO:
    image on top and heading and content renders as stack
    <col-sm> - stack render
  MINIMAL_HERO:
    miniature version of hero
    smaller image on the left and heading and text on the right,
    content text usually one liner
    <col-sm-4> <col-sm-8>
  DEFAULT: ( usage in case statments )
    similar to SUB_HERO but smaller in size based on layout
    <col-sm> - stack render
  FULL_WIDTH:
    this is to denote expanding to full-width in the case of side bar e.g - article detail presenter (sidebar)
*/
export const HERO = 'hero';
export const FULL_WIDTH = 'full-width';
export const SUB_HERO = 'sub-hero';
export const MINIMAL_HERO = 'minimal-hero';

// article number limit constants
export const TRENDING_ARTICLE_COUNT = 6;
export const LATEST_ARTICLE_COUNT = 6;
export const RELATED_ARTICLES_COUNT = 2;
export const RELATED_PRODUCTS_COUNT = 3;
export const RELEVANT_ARTICLE_COUNT = 3;

// market comparison product recommendation count
export const MARKET_COMPARISON_INITIAL_PRODUCT_COUNT = 5;

export const IMAGE_BASE_LINK = APP_CONFIG.aemImagesPath;

export const CIP_LOGIN_URL = `${APP_CONFIG.authLoginPath}?response_type=id_token%20token
&client_id=${APP_CONFIG.authClientId}&
scope=${APP_CONFIG.authScope}&redirect_uri=${APP_CONFIG.authRedirectPath}&nonce=`;

export const SECURE_AUTH_LOGIN_URL = `${APP_CONFIG.secureAuthLoginPath}?response_type=code
&client_id=${APP_CONFIG.secureAuthClientId}&
scope=${APP_CONFIG.secureAuthScope}&redirect_uri=${APP_CONFIG.secureAuthRedirectPath}&state=`;

export const SECURE_AUTH_PARTNER_BY_PASS = APP_CONFIG.secureAuthPartnerByPass === 'Y';

export const TCOM_VANTAGE_URL = APP_CONFIG.tcomVantageUrl;

export const AUTH_API_SUCCESS_USER_INFO = 'AUTH_API_SUCCESS_USER_INFO';
export const AUTH_API_FAILURE_USER_INFO = 'AUTH_API_FAILURE_USER_INFO';
export const AUTH_API_REDIRECT_HOME_PAGE = 'AUTH_API_REDIRECT_HOME_PAGE';
export const AUTH_API_ACCESS_TOKEN_FAILURE = 'AUTH_API_ACCESS_TOKEN_FAILURE';

export const SECURE_AUTH_TOKEN_SUCCESS = 'SECURE_AUTH_TOKEN_SUCCESS';

// My Business Solution nav constants

export const ROUTE_PATHS = {
  homepage: {
    route: '/',
    icon: 'icon-home',
  },
  usage: {
    route: '/usage',
    childPath: '',
    name: 'Usage',
    icon: 'icon-check-usage',
  },
  marketComparison: {
    route: '/market-comparison',
    childPath: '',
    name: 'Market Comparison',
    icon: 'icon-file-sharing',
  },
  articleDetail: {
    route: '/articles',
    childPath: '/:articleId',
    name: '',
    icon: '',
  },
  error: {
    route: '/error',
    childPath: '',
    name: '',
    icon: '',
  },
  businessCase: {
    route: '/my-business-cases/business-case',
    childPath: '',
    name: 'Business Case',
    icon: '',
  },
  myBusinessCases: {
    route: '/my-business-cases',
    childPath: '',
    name: 'My Business Cases',
    icon: 'icon-business-centers',
  },
  vantage: {
    route: '/events',
    childPath: '',
    name: 'Vantage',
    icon: '',
  },
  hostedMigration: {
    route: '/exchange-business-mail',
    childPath: '',
    name: 'HostedMigration',
    icon: '',
  },
  businessPopMail: {
    route: '/business-pop-mail',
    childPath: '',
    name: 'BusinessPopMail',
    icon: '',
  },
  adaptiveMobilityExternal: {
    route: '/adaptive-mobility-calculator',
    childPath: '',
    name: 'adaptiveMobilityCalculator',
    icon: '',
  },
  partnerView: {
    route: '/partner-view',
    childPath: '',
    name: 'partnerView',
    icon: '',
  },

};

export const AUTHENTICATED_NAV_BUTTONS = [
  {
    id: 'marketComparison',
    routeMeta: ROUTE_PATHS.marketComparison,
  },
  {
    id: 'myBusinessCases',
    routeMeta: ROUTE_PATHS.myBusinessCases,
  },
];

export const WINDOW_START_POSITION = 0;
export const CIP_LOGOUT_URL = `${APP_CONFIG.authLogoutPath}?${APP_CONFIG.authLogoutRedirectPath}`;
export const BUSINESS_CASE_DATE_FORMAT = 'DD MMM, YYYY';

export const ERROR_CONTENT = {
  heading: 'Error',
  description: 'Something went wrong. Our team is looking into it. Please try later.',
};

export const SESSION_TIMEOUT_MINUTES = 100;

export const SESSION_TIMEOUT_RENEWAL = 12;
// export const SESSION_TIMEOUT_RENEWAL = 2; // for testing time out on local

export const DEBUG_MODE = APP_CONFIG.debugMode;
export const CURRENCY_DOLLAR_SIGN = '$';
export const MEDIA_TYPE_IS_VIDEO = 'VIDEO';
export const MEDIA_TYPE_IS_ARTICLE = 'ARTICLE';
export const MEDIA_TYPE_IS_CALLBACK = 'CALLBACK';

export const BOOTSTRAP_COLUMN_WIDTH = 12;
export const ANIMATION_DURATION = 500;
export const EMAIL_ADDRESS_ENTERED_TEXT = 'The email address entered has already been entered.';

const image = 'https://www.telstra.com.au/content/tcom/business-enterprise/_jcr_content/content/featuremodule_1936971686.img.jpg/1520976439041.jpg';

export const VANTAGE_AUTHORABLE_CONTENT = {
  articles: {
    title: 'Articles Associated With Your Vantage Experience',
    showMoreText: 'View more articles',
  },
  highlights: {
    title: 'Highlights & Trends',
    showMoreText: 'View more recommendations',
  },
  videos: {
    title: 'More from Telstra Vantage™ 2018',
    showMoreText: 'View more recommendations',
  },
  conversation: {
    title: 'Continue the conversation',
    content: [
      {
        imageUrl: image,
        imageAltText: '',
        title: 'Talk to your Account Executive',
        summary: 'Cras luctus nibh at risus venenatis suscipit. Nam sollicitudin, nibh nec aliquam vehicula, nulla libero sagittis diam.',
        buttonText: 'Request a call back',
        url: '#',
      }, {
        imageUrl: image,
        imageAltText: '',
        title: 'Find a Customer Contact Expert',
        summary: 'Access our network of experts and have your questions answered by an authority in the field.',
        buttonText: 'Expert finder',
        url: 'https://www.telstra.com.au/business-enterprise/expert-finder',
      }, {
        imageUrl: image,
        imageAltText: '',
        title: 'Get Support',
        summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam semper in turpis eget dignissim.',
        buttonText: 'Launch support',
        url: 'https://www.telstra.com.au/support',
      },
    ],
  },
  thanks: {
    title: 'Thanks from Telstra',
    content: [
      {
        imageAltText: 'Image',
        imageUrl: 'https://img.youtube.com/vi/ro33kHMbbaE/mqdefault.jpg',
        title: 'Free cisco Membership for attening Vantage',
        summary: 'Cras luctus nibh at risus venenatis suscipit. Nam sollicitudin, nibh nec aliquam vehicula, nulla libero sagittis diam.',
        buttonText: 'Find out more',
        url: 'https://www.telstra.com.au/small-business',
      },
      {
        imageAltText: 'Image',
        imageUrl: 'https://img.youtube.com/vi/ro33kHMbbaE/mqdefault.jpg',
        title: 'Free cisco Membership for attening Vantage',
        summary: 'Cras luctus nibh at risus venenatis suscipit. Nam sollicitudin, nibh nec aliquam vehicula, nulla libero sagittis diam.',
        buttonText: 'Find out more',
        url: 'https://www.telstra.com.au/small-business',
      },
      {
        imageAltText: 'Image',
        imageUrl: 'https://img.youtube.com/vi/ro33kHMbbaE/mqdefault.jpg',
        title: 'Free cisco Membership for attening Vantage',
        summary: 'Cras luctus nibh at risus venenatis suscipit. Nam sollicitudin, nibh nec aliquam vehicula, nulla libero sagittis diam.',
        buttonText: 'Find out more',
        url: 'https://www.telstra.com.au/small-business',
      },
    ],
  },
  discover: {
    title: 'Discover more tailored solutions for your business',
    content: [
      {
        icon: 'icon-mobile',
        title: 'Mobility Solutions',
        summary: 'Cras luctus nibh at risus venenatis suscipit. Nam sollicitudin, nibh nec aliquam vehicula, nulla libero sagittis diam.',
        buttonText: 'Find out more',
        url: 'http://telstra.com.au',
        listType: 'article',
      },
      {
        icon: 'icon-collaboration',
        title: 'Collaboration',
        summary: 'Access our network of experts and have your questions answered by an authority in the field.',
        buttonText: 'Find out more',
        url: 'http://telstra.com.au',
        listType: 'article',
      },
      {
        icon: 'icon-cloud',
        title: 'Cloud Services',
        summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam semper in turpis eget dignissim.',
        buttonText: 'Find out more',
        url: 'http://telstra.com.au',
        listType: 'article',
      },
      {
        icon: 'icon-customer-contact-solution',
        title: 'Customer Contact',
        summary: 'Access our network of experts and have your questions answered by an authority in the field.',
        buttonText: 'Find out more',
        url: 'http://telstra.com.au',
        listType: 'article',
      },
      {
        icon: 'icon-network-australia-wide',
        title: 'Network Services',
        summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam semper in turpis eget dignissim.',
        buttonText: 'Find out more',
        url: 'http://telstra.com.au',
        listType: 'article',
      },
      {
        icon: 'icon-public-safety-security',
        title: 'Security Products',
        summary: 'Access our network of experts and have your questions answered by an authority in the field.',
        buttonText: 'Find out more',
        url: 'http://telstra.com.au',
        listType: 'article',
      },
      {
        icon: 'icon-iot',
        title: 'Internet of Things',
        summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam semper in turpis eget dignissim.',
        buttonText: 'Find out more',
        url: 'http://telstra.com.au',
        listType: 'article',
      },
    ],
  },
};

// vantage page types
export const PAGE_TYPE_GENERIC = 'unrestricted';
export const PAGE_TYPE_TRIPREPORT = 'tripReport';
export const PAGE_TYPE_FOLLOWUP = 'followUp';
export const PAGE_TYPE_UNATTENDED = 'unattended';


// SSM related constants
export const SSM_PAGE_HEADING = 'Telstra CustomNet Exit';
export const API_GET_SSM_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.ssmGetCustomerDataEndpoint;
export const API_POST_SSM_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.ssmSubmitCustomerDataEndpoint;
export const API_INITIATE_GET_SSM_CUSTOMER_DATA = 'API_INITIATE_GET_SSM_CUSTOMER_DATA';
export const API_COMPLETE_GET_SSM_CUSTOMER_DATA = 'API_COMPLETE_GET_SSM_CUSTOMER_DATA';
export const API_INITIATE_SUBMIT_SSM_CUSTOMER_DATA = 'API_INITIATE_SUBMIT_SSM_CUSTOMER_DATA';
export const API_COMPLETE_SUBMIT_SSM_CUSTOMER_DATA = 'API_COMPLETE_SUBMIT_SSM_CUSTOMER_DATA';
export const API_COMPLETE_SUBMIT_SSM_SITE_CUSTOMER_DATA = 'API_COMPLETE_SUBMIT_SSM_SITE_CUSTOMER_DATA';
export const API_POST_AUTO_SAVE_ENDPOINT = API_ENDPOINTS.autoSaveDataEndpoint;

export const SELECTION_OPTION_MIGRATE_ALL = 'SELECTION_OPTION_MIGRATE_ALL';
export const SELECTION_OPTION_CANCEL_ALL = 'SELECTION_OPTION_CANCEL_ALL';
export const SELECTION_OPTION_REVIEW = 'SELECTION_OPTION_REVIEW';

export const RADIO_BUTTON_CONFIRM_ID = 'RADIO_BUTTON_CONFIRM_ID';
export const RADIO_BUTTON_REVIEW_ID = 'RADIO_BUTTON_REVIEW_ID';

export const RADIO_BUTTON_CANCEL_ALL_ID = 'RADIO_BUTTON_CANCEL_ALL_ID';
export const RADIO_BUTTON_CANCEL_ON_DEADLINE_ID = 'RADIO_BUTTON_CANCEL_ON_DEADLINE_ID';

export const SITE_CONTACT_FIRST_NAME = 'siteContactFirstName';
export const SITE_CONTACT_LAST_NAME = 'siteContactLastName';
export const SITE_CONTACT_PHONE = 'siteContactPhone';
export const SITE_CONTACT_EMAIL = 'siteContactEmail';

export const PORT_TYPE_ANALOG = 'ANALOG';
export const PORT_TYPE_P_PHONE = 'P-PHONE';
export const PORT_TYPE_MOBILE = 'MOBILE';

export const ADDRESS_API_BASE_PATH = API_ENDPOINTS.addressSearchBasePath;
export const ADDRESS_SEARCH_ENDPOINT = API_ENDPOINTS.addressSearchResultsEndpoint;
export const ADDRESS_DETAIL_ENDPOINT = API_ENDPOINTS.addressDetailsEndpoint;

export const ADDRESS_SEARCH_SUCCESS = 'ADDRESS_SEARCH_SUCCESS';

// Hosted migration related constants
export const API_COMPLETE_HOSTED_MIGRATION_ENDPOINT = 'API_COMPLETE_HOSTED_MIGRATION_ENDPOINT';

export const HOSTED_MIGRATION_MIGRATE_RADIO_BUTTON = 'HOSTED_MIGRATION_MIGRATE_RADIO_BUTTON';
export const HOSTED_MIGRATION_CANCEL_RADIO_BUTTON = 'HOSTED_MIGRATION_CANCEL_RADIO_BUTTON';
export const HOSTED_MIGRATION_REDIRECT_RADIO_BUTTON = 'HOSTED_MIGRATION_REDIRECT_RADIO_BUTTON';

export const CUSTOMER_DETAILS_COMPANY_TRADING_NAME = 'companyName';
export const CUSTOMER_DETAILS_ABN_ACN = 'abnAndAcn';
export const CUSTOMER_DETAILS_STREET_ADDRESS = 'streetAddress';
export const CUSTOMER_DETAILS_SUBURB = 'suburb';
export const CUSTOMER_DETAILS_STATE = 'state';
export const CUSTOMER_DETAILS_POST_CODE = 'postcode';
export const CUSTOMER_DETAILS_FIRST_NAME = 'firstName';
export const CUSTOMER_DETAILS_LAST_NAME = 'lastName';
export const CUSTOMER_DETAILS_BILL_OR_ACCOUNT_NUMBER = 'billOrAccountNo';
export const CUSTOMER_DETAILS_ADMIN_EMAIL_ADRESS = 'adminEmailAddress';
export const CUSTOMER_DETAILS_CONTACT_PHONE_NUMBER = 'contactPhoneNumber';

export const API_GET_HOSTED_MIGRATION_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.hostedMigrationGetDataEndpoint;
export const API_INITIATE_HOSTED_MIGRATION_CUSTOMER_DATA_ENDPOINT = 'API_INITIATE_HOSTED_MIGRATION_CUSTOMER_DATA_ENDPOINT';

export const HOSTED_MIGRATION_CURRENT_SERVICES_OTHER = 'other';

export const API_POST_HOSTED_MIGRATION_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.hostedMigrationSubmitDataEndpoint;
export const API_INITIATE_SUBMIT_HOSTED_MIGRATION_CUSTOMER_DATA = 'API_INITIATE_SUBMIT_HOSTED_MIGRATION_CUSTOMER_DATA';
export const API_COMPLETE_SUBMIT_HOSTED_MIGRATION_CUSTOMER_DATA = 'API_COMPLETE_SUBMIT_HOSTED_MIGRATION_CUSTOMER_DATA';

export const SERVICE_TERM_PURCHASE_RADIO_BUTTON = 'Purchase';
export const SERVICE_TERM_RENTAL_RADIO_BUTTON = 'Rental';

export const SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS = 'featuresPacks';
export const SERVICE_TERM_DEVICE_TYPE_HANDSETS = 'handsets';
export const SERVICE_TERM_DEVICE_TYPE_POWERPACKS = 'powerPacks';
export const SERVICE_TERM_DEVICE_TYPE_HEADSET = 'headset';
export const SERVICE_TERM_DEVICE_TYPE_INTEGRATEDACCESSDEVICES = 'integratedAccessDevices';
export const SERVICE_TERM_DEVICE_TYPE_CALLCENTER = 'callCenter';
export const SERVICE_TERM_ADDITIONAL_INFO = 'info';

export const PAYMENT_TYPE_MONTHLY = 'monthly';
export const PAYMENT_TYPE_ONEOFF = 'oneOff';

export const SSM_REVIEW_SERVICES_VIEW = 'reviewServices';
export const SSM_ORDER_SUMMARY_VIEW = 'orderSummary';

export const ORDER_REVIEW_STATUS = 'toBeReviewed';
export const ORDER_PARTIALLY_SAVED_STATUS = 'partiallySaved';
export const ORDER_READY_FOR_SUBMISSION_STATUS = 'readyForSubmission';
export const ORDER_SUBMITTED_STATUS = 'submitted';

export const ISDN_GOTOOPTION_MIGRATE_ALL_TIPT = 'ISDN_GOTOOPTION_MIGRATE_ALL_TIPT';
export const ISDN_GOTOOPTION_REDIRECT_OR_CANCEL = 'ISDN_GOTOOPTION_REDIRECT_OR_CANCEL';
export const INPUT_TYPE_NUMBER = 'number';
export const INPUT_TYPE_INTEGER = 'integer';
export const ISDN_GOTOOPTION_MIGRATE_ALL_BSIP = 'ISDN_GOTOOPTION_MIGRATE_ALL_BSIP';
export const BSIP_CALLING_PLAN_SMALL = 'smallPlan';
export const BSIP_CALLING_PLAN_MEDIUM = 'mediumPlan';
export const BSIP_CALLING_PLAN_LARGE = 'largePlan';
export const BSIP_SERVICE_TERM_DEFAULT_CONTRACT_TERM = '24 months';

export const BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS = 'featuresPacks';
export const BSIP_SERVICE_TERM_DEVICE_TYPE_NUMBER_CHARGES = 'numberCharges';
export const BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN = 'callingPlan';
export const BSIP_SERVICE_TERM_DEVICE_TYPE_NTU = 'ntu';
export const ENABLE_LIVE_CHAT = APP_CONFIG.enableLiveChat;
export const LIVE_CHAT_SUPPORTED_PRODUCTS = APP_CONFIG.liveChatProducts;

// business pop mail constants

export const API_INITIATE_BUSINESS_POP_MAIL_ENDPOINT = 'API_INITIATE_BUSINESS_POP_MAIL_ENDPOINT';
export const API_INITIATE_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT = 'API_INITIATE_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT';
export const API_GET_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.businessPopMailGetDataEndpoint;
export const API_COMPLETE_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT = 'API_COMPLETE_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT';
export const BUSINESS_POP_MAIL_HOME_SCREEN = 'BUSINESS_POP_MAIL_HOME_SCREEN';
export const BUSINESS_POP_MAIL_REVIEW_SCREEN = 'BUSINESS_POP_MAIL_REVIEW_SCREEN';
export const API_POST_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.businessPopMailSubmitDataEndpoint;
export const API_INITIATE_SUBMIT_BUSINESS_POP_MAIL = 'API_INITIATE_SUBMIT_BUSINESS_POP_MAIL';
export const API_COMPLETE_SUBMIT_BUSINESS_POP_MAIL = 'API_COMPLETE_SUBMIT_BUSINESS_POP_MAIL';
export const TAM_REDIRECT_PATH = APP_CONFIG.businessPopMailTAMRedirectPath;

// Auto save related constants

export const API_INITIATE_AUTO_SAVE = 'API_INITIATE_AUTO_SAVE';
export const API_COMPLETE_AUTO_SAVE = 'API_COMPLETE_AUTO_SAVE';
export const AUTO_SAVE_TIMER_COUNT = parseInt(APP_CONFIG.autoSaveTimer, 10);
export const AUTO_SAVE_STATUS_SAVING = 'saving';

export const SITE_STATUS_PARTIALLY_SAVED = 'PARTIALLY_SAVED';
export const SITE_STATUS_SUBMITTED = 'SUBMITTED';

// ISDN Callback related constants

export const ISDN_CALLBACK_REQUEST_ENDPOINT = API_ENDPOINTS.isdnRequestCallback;
export const INITIATE_ISDN_CALLBACK_REQUEST = 'INITIATE_ISDN_CALLBACK_REQUEST';
export const COMPLETE_ISDN_CALLBACK_REQUEST = 'COMPLETE_ISDN_CALLBACK_REQUEST';

// SIP Connect related constants

export const ISDN_GOTOOPTION_MIGRATE_ALL_SIP_CONNECT = 'ISDN_GOTOOPTION_MIGRATE_ALL_SIP_CONNECT';
export const SIP_CALLING_PLAN_BUSINESS_LINE = 'businessLinePlan';
export const SIP_CALLING_PLAN_BUSINESS_TRUNK = 'businessTrunkPlan';
export const BUSINESS_LINE = 'BusinessLine';
export const BUSINESS_TRUNK = 'BusinessTrunk';
export const SIP_CALLING_PLAN_SELECT_OPTION = 'selectanoption';
export const SIP_CALLING_TRUNKS_5_HARD_CODE_TEXT = '5 Trunks';
export const SIP_CALLING_TRUNKS_5_HARD_CODE_VLAUE = 5;

export const SIP_CONNECT_NO_PABX = 'noPabx';
export const SIP_CONNECT_PABX_NOT_LISTED = 'notListed';
export const SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION = 'selectanoption';
export const SIP_CONNECT_PABX_MODEL_NOT_LISTED = "My model isn't listed";
export const SIP_CONNECT_VENDOR = 'vendor';
export const SIP_CONNECT_MODEL = 'model';

export const SIP_CONNECT_SERVICE_TERM_DEVICE_TYPE_ESTABLISHMENT_FEES = 'establishmentFees';
export const MIGRATE_TO_ENTERPRISE_TRUNK = 'migrateToEnterpriseTrunk';
export const REQUEST_CALL_BACK = 'Request call back';

export const BUSINESS_CONTINUITY = 'sipBusinessContinuity';
export const MOBILITY_CONTINUITY = 'sipMobility';
export const MOBILITY_ESTABLISHMENT_FEES = 'mobilityEstablishmentFees';
export const BUSINESS_CONTINUITY_ESTABLISHMENT_FEES = 'businessContinuityEstablishmentFees';

export const IAD_DEVICE_425 = 'IADDevice425';
export const IAD_DEVICE_270 = 'IADDevice270';
export const IAD_DEVICE_700 = 'IADDevice700';
export const IAD_DEVICE_NOT_REQUIRED = 'notRequired';
export const ONE_425 = 'one 425';
export const ONE_270 = 'one 270';
export const ONE_700 = 'one 700';
// authenticated view multiple product type support

export const API_END_POINT_GET_PRODUCT_TYPE = API_ENDPOINTS.identifyProductType;
export const SHOW_PRODUCT_SELECTION_OPTIONS = 'SHOW_PRODUCT_SELECTION_OPTIONS';
export const PRODUCT_SELECTION_HEADING = APP_CONFIG.productSelectionHeading;
export const PRODUCT_SELECTION_DATA = APP_CONFIG.productSelectionData;

// ffwd related constants

export const API_GET_FFWD_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.ffwdGetCustomerDataEndpoint;
export const API_POST_FFWD_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.ffwdSubmitCustomerDataEndpoint;
export const API_INITIATE_GET_FFWD_CUSTOMER_DATA = 'API_INITIATE_GET_FFWD_CUSTOMER_DATA';
export const API_COMPLETE_GET_FFWD_CUSTOMER_DATA = 'API_COMPLETE_GET_FFWD_CUSTOMER_DATA';
export const FFWD_RADIO_BUTTON_SUBMIT_ID = 'RADIO_BUTTON_SUBMIT_ID';
export const API_INITIATE_SUBMIT_FFWD_CUSTOMER_DATA = 'API_INITIATE_SUBMIT_FFWD_CUSTOMER_DATA';
export const API_COMPLETE_SUBMIT_FFWD_CUSTOMER_DATA = 'API_COMPLETE_SUBMIT_FFWD_CUSTOMER_DATA';
export const FFWD_RADIO_BUTTON_CONFIRM_ID = 'RADIO_BUTTON_CONFIRM_ID';
export const SIP_CONNECT_SERVICE_TERM_DEFAULT_CONTRACT_TERM = '12 months';
export const OLD_PLAN_TYPE = 'OldPlanTable';
export const NEW_PLAN_TYPE = 'NewPlanTable';
export const PLAN_TABLE_ACCOUNT_SELECTED_CLASS = 'selected-number';
export const PLAN_TABLE_ACCOUNT_SELECTED_CLASS_IN_USE = 'selected-number-in-use';
export const PLAN_TABLE_ACCOUNT_SELECTED_CLASS_NOT_IN_USE = 'selected-number-not-in-use';
export const PLAN_TABLE_ACCOUNT_NOT_SELECT_CLASS = 'not-selected-number';

// FFWD request Callback related constants
export const FFWD_CALLBACK_REQUEST_ENDPOINT = API_ENDPOINTS.ffwdRequestCallback;
export const INITIATE_FFWD_CALLBACK_REQUEST = 'INITIATE_FFWD_CALLBACK_REQUEST';
export const COMPLETE_FFWD_CALLBACK_REQUEST = 'COMPLETE_FFWD_CALLBACK_REQUEST';

// constants related to new header footer

export const ENABLE_NEW_HEADER_FOOTER_DESIGN = APP_CONFIG.enableNewHeaderFooterDesign;

// ngm related constants

export const API_INITIATE_GET_NGM_CUSTOMER_DATA = 'API_INITIATE_GET_NGM_CUSTOMER_DATA';
export const API_COMPLETE_GET_NGM_CUSTOMER_DATA = 'API_COMPLETE_GET_NGM_CUSTOMER_DATA';

export const API_GET_NGM_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.ngmGetCustomerDataEndpoint;
export const API_POST_NGM_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.ngmSubmitCustomerDataEndpoint;
export const API_GET_NGM_CUSTOMER_DOWNLOAD_CSV_FILE = API_ENDPOINTS.ngmDownloadCSVFile;
export const API_INITIATE_SUBMIT_NGM_CUSTOMER_DATA = 'API_INITIATE_SUBMIT_NGM_CUSTOMER_DATA';
export const API_COMPLETE_SUBMIT_NGM_CUSTOMER_DATA = 'API_COMPLETE_SUBMIT_NGM_CUSTOMER_DATA';

export const ISDN_GOTOOPTION_YET_TO_FILL_IN_DETAILS = 'ISDN_GOTOOPTION_YET_TO_FILL_IN_DETAILS';
export const NGM_YES_TEXT = 'YES';
export const NGM_NO_TEXT = 'NO';
export const API_POST_NGM_RECOMMEND_PLAN_DATA_ENDPOINT = API_ENDPOINTS.ngmRecommendPlanDataEndpoint;
export const API_INITIATE_POST_NGM_RECOMMEND_PLAN_DATA = 'API_INITIATE_POST_NGM_RECOMMEND_PLAN_DATA';
export const API_COMPLETE_POST_NGM_RECOMMEND_PLAN_DATA = 'API_COMPLETE_POST_NGM_RECOMMEND_PLAN_DATA';
export const API_INITIATE_GET_NGM_DOWNLOAD_CSV_FILE = 'API_INITIATE_POST_NGM_DOWNLOAD_CSV';
export const API_COMPLETE_GET_NGM_DOWNLOAD_CSV_FILE = 'API_COMPLETE_POST_NGM_DOWNLOAD_CSV';
// UCIDN related constanst

export const SECRET_KEY = 'ZTA4NDgwYTBjM2Y0ZWY1MDJjZDQwZGMwMGE2ZmFiNzU';
export const API_END_POINT_UCIDN_LIST = API_ENDPOINTS.uCidnListEndpoint;
export const SHOW_UCIDN_LIST_OPTIONS = 'SHOW_UCIDN_LIST_OPTIONS';
export const SHOW_PRODUCT_SELECTION_OPTIONS_CHANGE = 'SHOW_PRODUCT_SELECTION_OPTIONS_CHANGE';
export const COMPANY_NAME_PREFIX = APP_CONFIG.companyNamePrefix;

export const PRODUCT_SELECTION_ERROR = 'PRODUCT_SELECTION_ERROR';

export const ERROR_CONTENT_404 = {
  heading: 'Error',
  description: 'You are not authorised to view the page.',
};


// Adaptive mobility external constants

export const API_INITIATE_GET_AME_CUSTOMER_DATA = 'API_INITIATE_GET_AME_CUSTOMER_DATA';
export const API_COMPLETE_GET_AME_CUSTOMER_DATA = 'API_COMPLETE_GET_AME_CUSTOMER_DATA';
export const API_END_POINT_ADAPTIVE_MOBILITY_EXTERNAL = API_ENDPOINTS.ameGetCustomerDataEndpoint;
export const API_POST_AME_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.ameSubmitCustomerDataEndpoint;
export const API_INITIATE_SUBMIT_AME_CUSTOMER_DATA = 'API_INITIATE_SUBMIT_AME_CUSTOMER_DATA';
export const API_COMPLETE_SUBMIT_AME_CUSTOMER_DATA = 'API_COMPLETE_SUBMIT_AME_CUSTOMER_DATA';
export const API_POST_AME_SHOW_DATA_ENDPOINT = API_ENDPOINTS.ameShowResultsDataEndpoint;
export const API_INITIATE_SUBMIT_AME_SHOW_DATA = 'API_INITIATE_SUBMIT_AME_SHOW_DATA';
export const API_COMPLETE_SUBMIT_AME_SHOW_DATA = 'API_COMPLETE_SUBMIT_AME_SHOW_DATA';
export const API_POST_AME_TRACKING_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.ameShowResultsTrackingDataEndpoint;
export const API_INITIATE_TRACKING_SUBMIT_AME_CUSTOMER_DATA = 'API_INITIATE_TRACKING_SUBMIT_AME_CUSTOMER_DATA';
export const API_COMPLETE_TRACKING_SUBMIT_AME_CUSTOMER_DATA = 'API_COMPLETE_TRACKING_SUBMIT_AME_CUSTOMER_DATA';

// ams related constants

export const API_INITIATE_GET_AMS_CUSTOMER_DATA = 'API_INITIATE_GET_AMS_CUSTOMER_DATA';
export const API_COMPLETE_GET_AMS_CUSTOMER_DATA = 'API_COMPLETE_GET_AMS_CUSTOMER_DATA';

export const API_GET_AMS_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.amsGetCustomerDataEndpoint;
export const API_POST_AMS_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.amsSubmitCustomerDataEndpoint;
export const API_INITIATE_SUBMIT_AMS_CUSTOMER_DATA = 'API_INITIATE_SUBMIT_AMS_CUSTOMER_DATA';
export const API_COMPLETE_SUBMIT_AMS_CUSTOMER_DATA = 'API_COMPLETE_SUBMIT_AMS_CUSTOMER_DATA';

export const API_POST_AMS_OPTIMIZE_PLAN_DATA_ENDPOINT = API_ENDPOINTS.amsRecommendPlanDataEndpoint;
export const API_INITIATE_POST_AMS_OPTIMIZE_PLAN_DATA = 'API_INITIATE_POST_AMS_OPTIMIZE_PLAN_DATA';
export const API_COMPLETE_POST_AMS_OPTIMIZE_PLAN_DATA = 'API_COMPLETE_POST_AMS_OPTIMIZE_PLAN_DATA';
export const API_INITIATE_GET_AMS_DOWNLOAD_CSV_FILE = 'API_INITIATE_POST_AMS_DOWNLOAD_CSV';
export const API_COMPLETE_GET_AMS_DOWNLOAD_CSV_FILE = 'API_COMPLETE_POST_AMS_DOWNLOAD_CSV';

// SCT request Callback related constants
export const SCT_CALLBACK_REQUEST_ENDPOINT = API_ENDPOINTS.sctRequestCallback;
export const INITIATE_SCT_CALLBACK_REQUEST = 'INITIATE_SCT_CALLBACK_REQUEST';
export const COMPLETE_SCT_CALLBACK_REQUEST = 'COMPLETE_SCT_CALLBACK_REQUEST';

// SCT related constants
export const API_GET_SCT_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.sctGetCustomerDataEndpoint;
export const API_INITIATE_GET_SCT_CUSTOMER_DATA = 'API_INITIATE_GET_SCT_CUSTOMER_DATA';
export const API_COMPLETE_GET_SCT_CUSTOMER_DATA = 'API_COMPLETE_GET_SCT_CUSTOMER_DATA';

export const API_SCT_INITIATE_AUTO_SAVE = 'API_SCT_INITIATE_AUTO_SAVE';
export const API_SCT_COMPLETE_AUTO_SAVE = 'API_SCT_COMPLETE_AUTO_SAVE';
export const SCT_AUTO_SAVE_ENDPOINT = API_ENDPOINTS.sctAutoSaveDataEndpoint;

// Session related constants.
export const SESSION_RENEWAL_START = 'SESSION_RENEWAL_START';
export const SESSION_RENEWAL_COMPLETE = 'SESSION_RENEWAL_COMPLETE';
export const SESSION_RENEWAL_FAILED = 'SESSION_RENEWAL_FAILED';
export const SESSION_RENEWAL_POPUP_CLOSE = 'SESSION_RENEWAL_POPUP_CLOSE';

export const SESSION_RENEWAL_INPROGRESS_TEXT = APP_CONFIG.sessionRenewalInProgress;
export const SESSION_RENEWAL_COMPLETE_TEXT = APP_CONFIG.sessionRenewalComplete;
export const SESSION_RENEWAL_FAILED_TEXT = APP_CONFIG.sessionRenewalFailed;

// amc related constanst

export const API_INITIATE_GET_AMC_CUSTOMER_DATA = 'API_INITIATE_GET_AMC_CUSTOMER_DATA';
export const API_COMPLETE_GET_AMC_CUSTOMER_DATA = 'API_COMPLETE_GET_AMC_CUSTOMER_DATA';

export const API_GET_AMC_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.amcGetCustomerDataEndpoint;
export const API_POST_AMC_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.amcSubmitCustomerDataEndpoint;
export const API_INITIATE_SUBMIT_AMC_CUSTOMER_DATA = 'API_INITIATE_SUBMIT_AMC_CUSTOMER_DATA';
export const API_COMPLETE_SUBMIT_AMC_CUSTOMER_DATA = 'API_COMPLETE_SUBMIT_AMC_CUSTOMER_DATA';

export const API_POST_AMC_OPTIMIZE_PLAN_DATA_ENDPOINT = API_ENDPOINTS.amcRecommendPlanDataEndpoint;
export const API_INITIATE_POST_AMC_OPTIMIZE_PLAN_DATA = 'API_INITIATE_POST_AMC_OPTIMIZE_PLAN_DATA';
export const API_COMPLETE_POST_AMC_OPTIMIZE_PLAN_DATA = 'API_COMPLETE_POST_AMC_OPTIMIZE_PLAN_DATA';
export const API_INITIATE_GET_AMC_DOWNLOAD_CSV_FILE = 'API_INITIATE_POST_AMC_DOWNLOAD_CSV';
export const API_COMPLETE_GET_AMC_DOWNLOAD_CSV_FILE = 'API_COMPLETE_POST_AMC_DOWNLOAD_CSV';

// AMC request Callback related constants
export const AMC_CALLBACK_REQUEST_ENDPOINT = API_ENDPOINTS.amcRequestCallback;
export const INITIATE_AMC_CALLBACK_REQUEST = 'INITIATE_AMC_CALLBACK_REQUEST';
export const COMPLETE_AMC_CALLBACK_REQUEST = 'COMPLETE_AMC_CALLBACK_REQUEST';
export const AMC_DOWNLOAD_PROPOSAL_REQUEST_ENDPOINT = API_ENDPOINTS.amcDownloadCSVFile;
export const INITIATE_AMC_DOWNLOAD_PROPOSAL_REQUEST = 'INITIATE_AMC_DOWNLOAD_PROPOSAL_REQUEST';
export const COMPLETE_AMC_DOWNLOAD_PROPOSAL_REQUEST = 'COMPLETE_AMC_DOWNLOAD_PROPOSAL_REQUEST';

// AMP constants

export const API_INITIATE_GET_AMP_CUSTOMER_DATA = 'API_INITIATE_GET_AMP_CUSTOMER_DATA';
export const API_COMPLETE_GET_AMP_CUSTOMER_DATA = 'API_COMPLETE_GET_AMP_CUSTOMER_DATA';

export const API_GET_AMP_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.ampGetCustomerDataEndpoint;
export const API_POST_AMP_CUSTOMER_DATA_ENDPOINT = API_ENDPOINTS.ampSubmitCustomerDataEndpoint;
export const API_INITIATE_SUBMIT_AMP_CUSTOMER_DATA = 'API_INITIATE_SUBMIT_AMP_CUSTOMER_DATA';
export const API_COMPLETE_SUBMIT_AMP_CUSTOMER_DATA = 'API_COMPLETE_SUBMIT_AMP_CUSTOMER_DATA';

export const API_POST_AMP_OPTIMIZE_PLAN_DATA_ENDPOINT = API_ENDPOINTS.ampRecommendPlanDataEndpoint;
export const API_INITIATE_POST_AMP_OPTIMIZE_PLAN_DATA = 'API_INITIATE_POST_AMP_OPTIMIZE_PLAN_DATA';
export const API_COMPLETE_POST_AMP_OPTIMIZE_PLAN_DATA = 'API_COMPLETE_POST_AMP_OPTIMIZE_PLAN_DATA';
export const API_INITIATE_GET_AMP_DOWNLOAD_CSV_FILE = 'API_INITIATE_POST_AMP_DOWNLOAD_CSV';
export const API_COMPLETE_GET_AMP_DOWNLOAD_CSV_FILE = 'API_COMPLETE_POST_AMP_DOWNLOAD_CSV';
